<div class="main-panel">
  <!-- BEGIN : Main Content-->
  <div class="main-content">
    <div class="content-wrapper">
      <!--Statistics cards Starts-->
      <div class="row">


        <div class="col-xl-4 col-lg-6 col-md-6 col-12">
          <div class="card gradient-blackberry">
            <div class="card-content">
              <div class="card-body pt-2 pb-0">
                <div class="media">
                  <div class="media-body white text-left">
                    <h3 class="font-large-1 mb-0">{{OverallDevices.totalDevices}}</h3>
                    <span>Total Devices</span>
                  </div>
                  <div class="media-right white text-right">
                    <i class="icon-pie-chart font-large-1"></i>
                  </div>
                </div>
              </div>
              <div id="Widget-line-chart" class="height-75 WidgetlineChart WidgetlineChartshadow mb-2">
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-4 col-lg-6 col-md-6 col-12">
          <div class="card gradient-ibiza-sunset">
            <div class="card-content">
              <div class="card-body pt-2 pb-0">
                <div class="media">
                  <div class="media-body white text-left">
                    <h3 class="font-large-1 mb-0">{{OverallDevices.disconnectedDevice}}</h3>
                    <span>Disconnected</span>
                  </div>
                  <div class="media-right white text-right">
                    <i class="icon-power font-large-1"></i>
                  </div>
                </div>
              </div>
              <div id="Widget-line-chart1" class="height-75 WidgetlineChart WidgetlineChartshadow mb-2">
              </div>

            </div>
          </div>
        </div>

        <div class="col-xl-4 col-lg-6 col-md-6 col-12">
          <div class="card gradient-green-tea">
            <div class="card-content">
              <div class="card-body pt-2 pb-0">
                <div class="media">
                  <div class="media-body white text-left">
                    <h3 class="font-large-1 mb-0">{{OverallDevices.connectedDevices}}</h3>
                    <span>Connected Devices</span>
                  </div>
                  <div class="media-right white text-right">
                    <i class="icon-graph font-large-1"></i>
                  </div>
                </div>
              </div>
              <div id="Widget-line-chart2" class="height-75 WidgetlineChart WidgetlineChartshadow mb-2">
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row match-height">

        <div class="col-xl-12 col-lg-12 col-12 col-sm-12">
          <div class="card">
            <div class="card-header pb-2">
              <h4 class="card-title">Device Status</h4>

            </div>

            <div class="card-content">
              <div class="card-body card-dashboard table-responsive">
                <table  *ngIf="DatatableInint" name="realtime"datatable  class="table table-responsive-sm text-center" >
                  <thead>
                    <tr>
                      <th>Device Id</th>
                      <th>Name</th>
                      <th>Update Time</th>
                      <th>Connected Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of DeviceOld">
                      
                      <td>{{item.device_id}}</td>
                      <td>{{item.deviceName}}</td>
                      <td>{{item.lastUpdatedTime}}</td>
                      <td *ngIf="item.connected==1"><a class="btn white btn-round btn-success">Connected</a></td>
                      <td *ngIf="item.connected==0"><a class="btn white btn-round btn-danger">Disconnected</a></td>
                    </tr>
                  </tbody>
                </table>
                <!-- <table datatable *ngIf="!DatatableInint" name="realtime"datatable  class="table table-responsive-sm text-center" >
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Update Time</th>
                      <th>Connected Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of Device">

                      <td>{{item.deviceName}}</td>
                      <td>{{item.lastUpdatedTime}}</td>
                      <td *ngIf="item.connected==1"><a class="btn white btn-round btn-success">Connected</a></td>
                      <td *ngIf="item.connected==0"><a class="btn white btn-round btn-danger">Disconnected</a></td>
                    </tr>
                  </tbody>
                </table> -->
              </div>

            </div>


          </div>
        </div>
      </div>



    </div>
  </div>
  <!-- END : End Main Content-->

  <!-- BEGIN : Footer-->
  <footer class="footer footer-static footer-light">
    <p class="clearfix text-muted text-sm-center px-2"><span>Copyright &copy; 2020 <a href="https://www.nedogroup.com"
          id="pixinventLink" target="_blank" class="text-bold-800 primary darken-2">Nedo Corporation </a>, All rights
        reserved. </span></p>
  </footer>
  <!-- End : Footer-->

</div>


<!-- Button trigger modal -->
<button type="button" id="ExpireModalClick" class="btn btn-primary"  data-toggle="modal" data-target="#ExpireModal">
  Launch demo modal
</button>


<!-- Modal -->
<div class="modal fade"  id="ExpireModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header bg-danger white">
        <h4 class="modal-title" id="myModalLabel10">Waranty Alert</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h5>Your Waranty is going to expire soon</h5>
        <p>Days Left :{{DaysLeft}}</p>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger" data-dismiss="modal">Close</button>

      </div>
    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <h3 style="color: white">Please Wait ... </h3>
  </ngx-spinner>
